import { render, staticRenderFns } from "./PurchaseRequestDetail.vue?vue&type=template&id=c7c54d7e&"
import script from "./PurchaseRequestDetail.vue?vue&type=script&lang=js&"
export * from "./PurchaseRequestDetail.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseRequestDetail.vue?vue&type=style&index=0&id=c7c54d7e&prod&lang=css&"
import style1 from "./PurchaseRequestDetail.vue?vue&type=style&index=1&id=c7c54d7e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports